import React, { useState } from "react";
import { connect } from "react-redux";
import { dl_insurances } from "../../reducers/dl_insurance.reducer";
import { dl_insuranceActions, dealjacketActions, alertActions } from "../../actions";
import { dl_insuranceConstants } from "../../constants";
import { OrgDropdown } from "../org/OrgDropdown";

// Copied from EditDealName
function Feedback(props) {
  const {
    heading,
    subheading,
    activity,
    data,
    prompt,
    alert_message,
    alert_type
  } = props;

  const spinner = require("../../images/spinner.gif");

  const [newDealNumber, setNewDealNum] = useState();

  let activity_display = undefined;

  if (activity == "found_a_match") {
    activity_display = data.map((jacket) => (
      <div className="matchingJacketDetails" key={ jacket.deal_jacket_id }>
        <p>Display Name: {jacket.display_name}</p>
        <p>ID: {jacket.deal_jacket_id}</p>
        <p>Name: {jacket.deal_jacket_name}</p>
        <p>Status: {jacket.deal_jacket_status}</p>
        <p>Type: {jacket.deal_jacket_type}</p>
        <p>Number: {jacket.deal_number}</p>
        <p>Customer Name: {jacket.customer_name || "TBD"}</p>
        <p>Organization: {jacket.org_id}</p>
    </div>
    ));
    if (data.length > 1) {
      activity_display.unshift(
        <h4 key={ "heading" }>Warning: Found multiple matches.</h4>
      );
    }
  }

  if (activity == "adding_files") {
    activity_display = <div className="addingFilesMessage">
      <p>Adding files...</p>
    </div>
  }

  return <>
    <div className="dlInsuranceFeedbackContainer">
      <h2>{heading}</h2>
      <h3>{subheading}</h3>

      <div className="dlInsuranceFeedbackActivity">
        {activity_display}
      </div>

      <div className="dlInsuranceFeedbackPrompt">
        {prompt}
      </div>

      {alert_display(alert_message, alert_type)}

    </div>
  </>
}

function alert_display(message, type = "notice") {
  if (!message) return "";
  return <div className={ "dlInsuranceFeedbackAlert " + type}>
    <p>{message}</p>
  </div>
}

function mapStateToProps(state) {
  const { dl_insurances } = state;
  return {
  };
}

const actionCreators = {};

const connectedFeedback = connect(
  mapStateToProps,
  actionCreators
)(Feedback);

export { connectedFeedback as Feedback };
